"use strict";

class SyncRetryError extends Error {
  constructor(retryAt, reason) {
    super(reason);
    this.name = "SyncRetryError";
    this.retryAt = retryAt;
    this.reason = reason;
  }
}

module.exports = SyncRetryError;
